export default "https://d1e6s5z4lzmgxx.cloudfront.net/1e48d3d4-9cd4-48c4-b169-1af184d58c4c/images/applause-icon.png?f4925efc152c51192b1a2cc8f7b8b803";